import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ResourcesPage() {
  const articles = [
    {
      title: 'Are ChatGPT Ads Real? What Florida Businesses Should Do Now',
      excerpt: 'OpenAI announced plans to test ads in ChatGPT. Here\'s what Florida businesses need to know and how to prepare for this game-changing opportunity.',
      category: 'ChatGPT Ads',
      readTime: '8 min read',
      link: '#'
    },
    {
      title: 'GEO vs SEO: How Florida Companies Win AI Search',
      excerpt: 'Traditional SEO gets you ranked in Google. GEO gets you recommended by AI assistants. Learn the key differences and why you need both strategies.',
      category: 'GEO Strategy',
      readTime: '10 min read',
      link: '#'
    },
    {
      title: 'The 5-Minute Rule: Why Speed-to-Lead Wins in Florida Home Services',
      excerpt: 'Studies show responding within 5 minutes increases conversion by 400%. Discover how AI voice agents help Florida contractors never miss another lead.',
      category: 'Voice AI',
      readTime: '6 min read',
      link: '#'
    },
    {
      title: 'How AI Assistants Choose Which Businesses to Recommend',
      excerpt: 'Understanding the signals AI platforms use when forming recommendations—and how to optimize your business to be the one they suggest.',
      category: 'AI Marketing',
      readTime: '12 min read',
      link: '#'
    },
    {
      title: 'AI Voice Agents for Roofers/HVAC: Booking More Jobs Without More Staff',
      excerpt: 'Real-world examples of how Florida home services companies use AI voice agents to capture after-hours emergencies and qualify leads automatically.',
      category: 'Voice AI',
      readTime: '9 min read',
      link: '#'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="relative overflow-hidden bg-white grid-bg pt-36 pb-20">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(13,148,136,0.14), transparent 58%), radial-gradient(ellipse at 85% 20%, rgba(249,115,22,0.10), transparent 55%)' }}
        ></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
            <div className="eyebrow">Resources</div>
            <h1 className="mt-6 h-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
              Resources & Insights
            </h1>
            <p className="mt-6 text-lg md:text-xl text-slate-600 font-body font-light max-w-2xl">
              Learn how to win the AI era with actionable guides and industry insights.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-12">
            <div className="flex flex-wrap gap-3 justify-center">
              <button className="px-6 py-2 bg-teal-500 text-navy-900 font-semibold rounded-full whitespace-nowrap cursor-pointer">
                All Articles
              </button>
              <button className="px-6 py-2 bg-navy-50 text-navy-700 font-semibold rounded-full hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                ChatGPT Ads
              </button>
              <button className="px-6 py-2 bg-navy-50 text-navy-700 font-semibold rounded-full hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                GEO Strategy
              </button>
              <button className="px-6 py-2 bg-navy-50 text-navy-700 font-semibold rounded-full hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                Voice AI
              </button>
              <button className="px-6 py-2 bg-navy-50 text-navy-700 font-semibold rounded-full hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                AI Marketing
              </button>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {articles.map((article, index) => (
              <div key={index} className="bg-white border-2 border-navy-100 rounded-2xl overflow-hidden hover:border-teal-300 hover:shadow-xl transition-all group">
                <div className="h-48 bg-gradient-to-br from-navy-900 to-navy-800 flex items-center justify-center">
                  <i className="ri-article-line text-orange-400 text-6xl opacity-70"></i>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="px-3 py-1 bg-teal-50 text-teal-700 text-xs font-semibold rounded-full">
                      {article.category}
                    </span>
                    <span className="text-xs text-navy-500">{article.readTime}</span>
                  </div>
                  <h3 className="text-xl font-display font-bold text-navy-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-navy-600 text-sm mb-4 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <a href={article.link} className="inline-flex items-center text-teal-600 font-semibold text-sm hover:text-teal-700 transition-colors cursor-pointer">
                    Read Article
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-navy-50 rounded-2xl p-12 border-2 border-navy-100 text-center">
            <div className="mb-6">
              <i className="ri-file-text-line text-orange-400 text-5xl mb-4"></i>
            </div>
            <h2 className="text-3xl font-display font-bold text-navy-900 mb-4">
              More Articles Coming Soon
            </h2>
            <p className="text-base text-navy-600 mb-8 max-w-2xl mx-auto leading-relaxed">
              We're building a comprehensive library of AI marketing resources for Florida businesses. Subscribe to our newsletter to get notified when new articles are published.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <Link
                to="/audit"
                className="btn-primary px-8 py-4 whitespace-nowrap cursor-pointer"
              >
                Get Free AI Assessment
              </Link>
              <Link
                to="/contact"
                className="px-8 py-4 border border-navy-200 text-navy-900 font-bold rounded-lg hover:bg-navy-50 transition-all whitespace-nowrap cursor-pointer"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
